import { Trans } from "react-i18next";

export type PostingPhase = "submitting" | "reviewing" | "analyzing" | "posting";

export interface PostingTipsProps {
  phase: PostingPhase;
}

const TITLE_MAP: Record<PostingPhase, string> = {
  submitting: "Uploading your video...",
  reviewing: "Reviewing your video...",
  analyzing: "Analyzing video quality...",
  posting: "Posting your video...",
};

const SUBTITLE_MAP: Record<PostingPhase, string> = {
  submitting: "This may take a few seconds",
  reviewing: "This may take a few seconds",
  analyzing: "Optimizing your content for better performance",
  posting: "This may take a few seconds",
};

export const PostingTips = ({ phase }: PostingTipsProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-[4px]">
      <p className="text-[16px] font-semibold leading-[24px] text-kds-fg">
        <Trans>{TITLE_MAP[phase]}</Trans>
      </p>
      <p className="text-center text-[14px] leading-[1.4] text-kds-fg-soft">
        <Trans>{SUBTITLE_MAP[phase]}</Trans>
      </p>
    </div>
  );
};
